export const roundToDecimalPlaces = (
  numberToFormat: number,
  decimalPlaces = 2
) => {
  const multiplier = 10 ** decimalPlaces;
  return Math.round(numberToFormat * multiplier) / multiplier;
};
